export default "__VITE_ASSET__BkstU82L__"